import React from 'react';
import { Navigate } from 'react-router-dom';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import FeeConfiguration from './routes/FeeConfiguration';
import FeeDashboard from './routes/FeeDashboard';
import FeePayment from './routes/FeePayment';
import FeePaymentDetails from './routes/FeePaymentDetails';
import FeeReports from './routes/FeeDashboard/routes/FeeReports';

const FeesLazy = React.lazy(
	() => import(/* webpackChunkName : 'FeesLazy' */ './components')
);

export default (store) => [
	{
		path: 'home/fees',
		element: (
			<AsyncLoading
				component={<FeesLazy featureFlag="FeatureFlag:FeeModule" />}
			/>
		),
		children: [
			{
				index: true,
				element: <Navigate to="fee-dashboard" replace />,
			},
			...FeeConfiguration(store),
			...FeeDashboard(store),
			...FeePayment(store),
		],
	},
	...FeePaymentDetails(store),
	...FeeReports(store),
];
